<template>
  <div
    :class="['plv-ia-answer-card-wenda-option', {
      'plv-ia-answer-card-wenda-option-2':options.length >= 4,
      'plv-ia-answer-card-wenda-option-active':active,
      'plv-ia-answer-card-wenda-option-disabled':disabled
    }]"
    @click="$emit('click', options.join(''), disabled)"
  >
    <div class="plv-ia-answer-card-wenda-option__title">{{ options.length }} {{ t('plvIA.answerCard.optionsCount') }}</div>
    <div v-if="options.length < 4" class="plv-ia-answer-card-wenda-option__content">
      <div class="plv-ia-answer-card-wenda-option__content__row">
        <span v-for="(item, index) in options" :key="index">{{ item }}</span>
      </div>
    </div>
    <div v-if="options.length === 4" class="plv-ia-answer-card-wenda-option__content">
      <div class="plv-ia-answer-card-wenda-option__content__row">
        <span v-for="(item, index) in options.slice(0,2)" :key="index">{{ item }}</span>
      </div>
      <div class="plv-ia-answer-card-wenda-option__content__row">
        <span v-for="(item, index) in options.slice(2)" :key="index">{{ item }}</span>
      </div>
    </div>
    <div v-if="options.length > 4" class="plv-ia-answer-card-wenda-option__content">
      <div class="plv-ia-answer-card-wenda-option__content__row">
        <span v-for="(item, index) in options.slice(0,3)" :key="index">{{ item }}</span>
      </div>
      <div class="plv-ia-answer-card-wenda-option__content__row">
        <span v-for="(item, index) in options.slice(3)" :key="index">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';

export default {
  mixins: [Locale],
  props: {
    options: {
      type: Array,
      default() {
        return ['A', 'B'];
      }
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
$blue: #45ACFF;

.plv-ia-answer-card-wenda-option {
  float: left;
  box-sizing: border-box;
  width: 120px;
  height: 120px;
  border: 1px solid #CFD8DC;
  padding-top: 33px;
  text-align: center;
  margin: 0 20px 20px 0;
  cursor: pointer;
}
.plv-ia-answer-card-wenda-option-2 {
  padding-top: 20px;
}
.plv-ia-answer-card-wenda-option-active {
  border-color: $blue;
  .plv-ia-answer-card-wenda-option__title {
    color: $blue;
  }
  .plv-ia-answer-card-wenda-option__content__row {
    >span {
      color: $blue;
      background-color: #C0E3FF;
    }
  }
}
.plv-ia-answer-card-wenda-option-disabled {
  border-color: #EDEDED;
  cursor: not-allowed;
  .plv-ia-answer-card-wenda-option__title {
    color: #9E9E9E;
  }
  .plv-ia-answer-card-wenda-option__content__row {
    >span {
      background-color: #EDEDED;
      color: #9E9E9E;
    }
  }
}
.plv-ia-answer-card-wenda-option__title {
  color: #546E7A;
  margin-bottom: 7px;
}
.plv-ia-answer-card-wenda-option__content__row {
  margin-bottom: 3px;
  text-align: center;
  font-size: 0;
  >span {
    display: inline-block;
    width: 24px;
    line-height: 24px;
    margin: 0 1.5px;
    background: #EDF1F7;
    border-radius: 2px;
    font-size: 14px;
    color: #546E7A;
  }
}
</style>
